import {Archive, Bill, CreditCart, Report} from "src/components/common/NdIcons/SvgCollection"

/**
 * Menu icon per nature cycle.
 *
 * Kept apart from `nature-cycle-routes`, which reaches the `Document` view and through it the
 * routing config: importing that module to read an icon dragged its consumer into the
 * `routeConfig` → `nature-cycle-routes` → `Document` → `Routing` → `routeConfig` cycle, where
 * whichever module the run entered by decided whether `buildNatureRoutes` was assigned yet.
 * This module imports nothing but the icons, so reading one enters no cycle at all.
 */
export const ICON_BY_CYCLE = {
    O_2_C: <Bill />,
    P_2_P: <CreditCart />,
    MISC: <Archive />,
    REPORT: <Report />
}
